import { useTranslation } from 'react-i18next';
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import type { TechnicalDistribution } from '../types';

const DEVICE_COLORS = ['#2c6cff', '#ff6526', '#f3f3f4'];

export const ComparisonDeviceCharts = ({
  dataA,
  dataB,
}: {
  dataA: TechnicalDistribution;
  dataB: TechnicalDistribution;
}) => {
  const { t } = useTranslation('analytics');
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <DeviceDonut data={dataA} title={`${t('devices.title')} — ${t('comparator.webinarA')}`} />
      <DeviceDonut data={dataB} title={`${t('devices.title')} — ${t('comparator.webinarB')}`} />
    </div>
  );
};

const DeviceDonut = ({ data, title }: { data: TechnicalDistribution; title: string }) => {
  const chartData = data.devices.map((d) => ({
    name: d.label,
    value: d.count,
    percentage: d.percentage,
  }));

  return (
    <div className="bg-white border border-[#f3f3f4] rounded-[16px] p-6 shadow-sm">
      <h4 className="text-sm font-medium text-[#2e2e30] mb-6">{title}</h4>

      <div className="flex items-center gap-8">
        <div className="h-[180px] w-[180px] relative">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={chartData}
                innerRadius={65}
                outerRadius={85}
                paddingAngle={5}
                dataKey="value"
              >
                {chartData.map((_, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={DEVICE_COLORS[index % DEVICE_COLORS.length]}
                    stroke="none"
                  />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>

        <div className="flex flex-col gap-4 flex-1">
          {chartData.map((item, index) => (
            <div key={item.name} className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div
                  className="size-2.5 rounded-full"
                  style={{ backgroundColor: DEVICE_COLORS[index % DEVICE_COLORS.length] }}
                />
                <span className="text-xs font-medium text-[#6d6e7a]">{item.name}</span>
              </div>
              <span className="text-sm font-bold text-dark">{item.percentage}%</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
